import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, apiErrorDetail } from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";
import { FadeIn } from "@/components/Motion";

export default function PublicPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, page: null, error: null });

  useSEO({
    title: state.page ? `${state.page.title} — K Nutrition` : "Pagina — K Nutrition",
    description: state.page ? state.page.content.slice(0, 160) : "K Nutrition — Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista a Salerno.",
    path: `/pagine/${slug}`,
  });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, page: null, error: null });
    api
      .get(`/pages/${slug}`)
      .then(({ data }) => {
        if (!cancelled) setState({ loading: false, page: data.page, error: null });
      })
      .catch((e) => {
        if (!cancelled) setState({ loading: false, page: null, error: apiErrorDetail(e) });
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return (
    <section className="pt-28 lg:pt-36 pb-20 min-h-[60vh]" data-testid="public-page">
      <div className="max-w-[820px] mx-auto px-5 lg:px-12">
        {state.loading ? (
          <p className="text-charcoal/50 text-sm">Caricamento…</p>
        ) : state.page ? (
          <FadeIn>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-8" data-testid="public-page-title">
              {state.page.title}
            </h1>
            <div className="space-y-5 text-base lg:text-lg leading-relaxed text-charcoal/80 whitespace-pre-line" data-testid="public-page-content">
              {state.page.content}
            </div>
          </FadeIn>
        ) : (
          <div className="text-center py-20">
            <p className="font-display text-4xl mb-4">Pagina non trovata</p>
            <p className="text-charcoal/60 text-sm mb-8">{state.error}</p>
          </div>
        )}
        <Link to="/" data-testid="public-page-home" className="link-underline inline-flex items-center gap-2 mt-12 text-sm uppercase tracking-widest2 font-medium text-deeptaupe">
          <ArrowLeft size={15} /> Torna alla home
        </Link>
      </div>
    </section>
  );
}
